export default "__VITE_ASSET__C_rmhE3A__"